// RailBottomV2 — đáy MENU TRÁI ở giao diện v2. Chỉ còn UserMenu bản dưới 1024px.
//
// Nút "Giao diện cũ" ĐÃ BỎ (sếp Phú chốt 17/08): v2 là giao diện chính thức, không còn
// lối quay lui trong app. Công tắc `floating` bên v1 giữ nguyên — đó là đường ĐI TỚI v2
// cho máy chưa từng chọn.
//
// ⚠️ Slot `primaryBottomSlot` THAY THẾ HẲN khối avatar mặc định của cnv-ui — xem
// cnv-ui/src/components/layout/sidebar/SidebarPrimary.jsx:141 (`bottomSlot !== undefined
// ? bottomSlot : <avatar/>`). Nên nó phải tự lo luôn đường vào /me: menu SaaS KHÔNG có
// mục nào trỏ /me (grep `path: '/me'` trong AppLayout.jsx = 0), v1 vào được CHỈ nhờ
// avatar ở đúng chỗ này. Bỏ mà không thay = user mất lối vào cài đặt cá nhân.
//
// Desktop v2 đã có UserMenu trên thanh trên cùng nên bản ở đây chỉ hiện dưới 1024px —
// đúng ngưỡng mà `.v2-topbar` bị ẩn (ui-v2.css). Hai chỗ không bao giờ hiện cùng lúc;
// từ 1024px trở lên khối này rỗng nên ui-v2.css ẩn hẳn (khỏi trơ đường kẻ + padding).
//
// Chuông «Tin mới» (29/09) theo đúng luật đó: trên thanh trên cùng từ 1024px, ở đây dưới 1024px.

import UserMenu from '@cnv/ui/layout/sidebar/UserMenu';
import ProductNewsBell from '@cnv/ui/product-news/ProductNewsBell';

export default function RailBottomV2() {
  return (
    <div className="v2-rail-bottom shrink-0">
      <div className="lg:hidden pb-1">
        <ProductNewsBell variant="rail" />
      </div>
      <div className="v2-rail-bottom__user lg:hidden">
        <UserMenu />
      </div>
    </div>
  );
}
